import { Input } from '@/components/ui/input';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function YesNoSelect({ value, onChange, language }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="cyber-input w-full h-14 rounded-md px-4 text-base" data-testid="answer-input">
        <SelectValue placeholder={language === 'it' ? 'Seleziona...' : 'Select...'} />
      </SelectTrigger>
      <SelectContent className="bg-cyber-gray border-white/20">
        <SelectItem value="si" className="font-mono">{language === 'it' ? 'Sì' : 'Yes'}</SelectItem>
        <SelectItem value="no" className="font-mono">No</SelectItem>
      </SelectContent>
    </Select>
  );
}

export function TimeInput({ value, onChange, language }) {
  return (
    <Input
      type="time"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid="answer-input"
      className="cyber-input w-full h-14 rounded-md px-4 text-base"
      autoFocus
    />
  );
}

export function TransportSelect({ value, onChange, onKeyDown, language }) {
  const isOther = value.startsWith('altro:');
  
  return (
    <div className="space-y-3">
      <Select 
        value={isOther ? 'altro' : value} 
        onValueChange={(val) => {
          if (val === 'altro') {
            onChange('altro:');
          } else {
            onChange(val);
          }
        }}
      >
        <SelectTrigger className="cyber-input w-full h-14 rounded-md px-4 text-base" data-testid="answer-input">
          <SelectValue placeholder={language === 'it' ? 'Seleziona...' : 'Select...'} />
        </SelectTrigger>
        <SelectContent className="bg-cyber-gray border-white/20">
          <SelectItem value="auto" className="font-mono">{language === 'it' ? 'Auto' : 'Car'}</SelectItem>
          <SelectItem value="moto" className="font-mono">{language === 'it' ? 'Moto' : 'Motorcycle'}</SelectItem>
          <SelectItem value="mezzi_pubblici" className="font-mono">{language === 'it' ? 'Mezzi pubblici' : 'Public transport'}</SelectItem>
          <SelectItem value="bicicletta" className="font-mono">{language === 'it' ? 'Bicicletta' : 'Bicycle'}</SelectItem>
          <SelectItem value="a_piedi" className="font-mono">{language === 'it' ? 'A piedi' : 'On foot'}</SelectItem>
          <SelectItem value="altro" className="font-mono">{language === 'it' ? 'Altro' : 'Other'}</SelectItem>
        </SelectContent>
      </Select>
      
      {isOther && (
        <div className="fade-in-up">
          <label className="font-mono text-xs text-neon-cyan/70 mb-2 block">
            {language === 'it' ? 'Specifica quale altro mezzo:' : 'Specify other means:'}
          </label>
          <Input
            type="text"
            value={value.replace('altro:', '')}
            onChange={(e) => onChange(`altro:${e.target.value}`)}
            onKeyDown={onKeyDown}
            placeholder={language === 'it' ? 'Es: monopattino elettrico, taxi...' : 'Ex: electric scooter, taxi...'}
            data-testid="other-transport-input"
            className="cyber-input w-full h-12 rounded-md px-4 text-base"
            autoFocus
          />
        </div>
      )}
    </div>
  );
}

export function BullyingSelect({ value, onChange, language }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="cyber-input w-full h-14 rounded-md px-4 text-base" data-testid="answer-input">
        <SelectValue placeholder={language === 'it' ? 'Seleziona...' : 'Select...'} />
      </SelectTrigger>
      <SelectContent className="bg-cyber-gray border-white/20">
        <SelectItem value="fisico" className="font-mono">{language === 'it' ? 'Fisico' : 'Physical'}</SelectItem>
        <SelectItem value="verbale" className="font-mono">{language === 'it' ? 'Verbale' : 'Verbal'}</SelectItem>
        <SelectItem value="online" className="font-mono">{language === 'it' ? 'Online/Cyber' : 'Online/Cyber'}</SelectItem>
        <SelectItem value="sociale" className="font-mono">{language === 'it' ? 'Sociale/Esclusione' : 'Social/Exclusion'}</SelectItem>
        <SelectItem value="misto" className="font-mono">{language === 'it' ? 'Misto' : 'Mixed'}</SelectItem>
      </SelectContent>
    </Select>
  );
}
